<template>
  <b-tabs content-class="mt-3">
    <reservations-tab
      ref="tabReservationsTable"
      :entity-id="entityId">
    </reservations-tab>
    <galleries-tab
      ref="tabGalleriesTable"
      :entity-id="entityId">
    </galleries-tab>
    <messages-tab
      ref="tabMessagesTable"
      :entity-id="entityId">
    </messages-tab>
    <log-tab
      ref="tabLogTable"
      :entity-id="entityId"
      entity-type="user"
    />
  </b-tabs>
</template>

<script>
import {
  BTabs,
} from 'bootstrap-vue'
import reservationsTab from '@/views/pages/_components/_tab/_user/_update/reservations.vue'
import galleriesTab from '@/views/pages/_components/_tab/_user/_update/galleries.vue'
import messagesTab from '@/views/pages/_components/_tab/_user/_update/messages.vue'
import logTab from '@/views/pages/_components/_tab/_log/_list.vue'

export default {
  components: {
    BTabs,
    reservationsTab,
    galleriesTab,
    messagesTab,
    logTab,
  },
  props: {
    entityId: {
      type: Number,
      required: true
    }
  },
  methods: {
    refreshLog() {
      this.$refs.tabLogTable.initData()
    }
  }
}
</script>

<style scoped>

</style>
